<style scoped="scoped" lang="scss">
.container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-row-gap: 8px;
  grid-column-gap: 8px;
  padding: 8px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fafafa;
  align-items: start;
  justify-items: stretch;
}

@media (max-width: 1200px) {
  .container {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .container {
    grid-template-columns: repeat(2, 1fr);
  }
}

.fixed-width {
  width: 100%;
  height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 4px 6px;
  box-sizing: border-box;
  margin: 0;
  font-size: 12px;
}

.is-selected {
  background-color: #409eff !important;
  color: #ffffff !important;
  border-color: #409eff !important;
}

.is-selected:hover {
  background-color: #66b1ff !important;
  border-color: #66b1ff !important;
}
</style>

<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/trial/mold/record/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="yt.conditions.woNo" clearable></el-input>
          </el-form-item>
          <el-form-item :label="$t('mojumingcheng')">
            <yi_data_select :multiple="true" :type="'mould'" :ids.sync="yt.conditions.mouldIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('zhuangtai')">
            <el-select v-model="yt.conditions.status" clearable filterable :placeholder="$t('qingxuanze')">
              <el-option :label="$t('youxiao')" :value="1"></el-option>
              <el-option :label="$t('zuofei')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipmentAll'" :queryFilter="e => e.typeId === 1" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('yijieshu')">
            <el-select v-model="yt.conditions.isEnd" clearable filterable :placeholder="$t('qingxuanze')">
              <el-option :label="$t('shi')" :value="true"></el-option>
              <el-option :label="$t('fou')" :value="false"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('kaishishijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startTimeStart" :end.sync="yt.conditions.startTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shengchengtingjijilu')">
            <el-select v-model="yt.conditions.isGenEqExcRec" clearable filterable :placeholder="$t('qingxuanze')">
              <el-option :label="$t('weishengcheng')" :value="0"></el-option>
              <el-option :label="$t('yishengcheng')" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :idsPath.sync="yt.conditions.orgIds" :ids.sync="yt.conditions.selecteOrgId"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'id desc' })">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <template #buttonsL>
        <el-button size="mini" type="primary" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialogInsert)" v-if="utils.checkPower('web_equipment_trial_mold_record_createOne')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>

      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>

      <template #shichang(min)="scope">
        <span v-if="scope.row && scope.row.startTime && scope.row.endTime">
          {{ calcDurationMin(scope.row.startTime, scope.row.endTime) }}
        </span>
      </template>

      <template #zhuangtai="scope">
        <el-tag v-if="scope.row && (scope.row.status === 1 || scope.row.status === '1')" size="mini" type="success">
          {{ $t('youxiao') }}
        </el-tag>
        <el-tag v-else-if="scope.row && (scope.row.status === 0 || scope.row.status === '0')" size="mini" type="danger">
          {{ $t('zuofei') }}
        </el-tag>
      </template>

      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_equipment_trial_mold_record_updateOne')">
            <el-button v-if="!scope.row.endTime && scope.row && (scope.row.status === 1 || scope.row.status === '1')" type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1', beforeShowEditDialogEdit)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="utils.checkPower('web_equipment_trial_mold_record_void')">
            <el-button v-if="scope.row && (scope.row.status === 1 || scope.row.status === '1')" type="text" class="font-color-danger" :loading="yt.editObj.loading" @click="voidRow(scope.row)">{{ $t('zuofei') }}</el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body" @close="handleDialogClose">
      <template v-if="yt.editObj && (yt.editObj.action === 'xinzeng' || yt.editObj.action === 'bianji')">
        <div class="dialog-scroller">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" :model="yt.editObj">
            <el-form-item :label="$t('shengchangongdanhao')">
              <el-select
                v-model="yt.editObj.woId"
                filterable
                clearable
                :loading="woLoading"
                :placeholder="$t('qingxuanze')"
                @change="handleWoChange"
                @visible-change="handleWoDropdownVisibleChange"
              >
                <el-option v-for="item in woOptions" :key="item.id" :label="item.no" :value="item.id">
                  <span style="display: inline-block; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {{ item.no }}
                  </span>
                  <span style="float: right; color: #909399; margin-left: 12px;">
                    {{ woStatusText(item) }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('shebeimingcheng')" required>
              <yi_data_select :type="'equipmentAll'" :queryFilter="e => e.belongId == null" :ids.sync="yt.editObj.equipmentId"> </yi_data_select>
            </el-form-item>

            <el-form-item :label="$t('mojumingcheng')">
              <yi_data_select :type="'mould'" :ids.sync="yt.editObj.mouldId"> </yi_data_select>
            </el-form-item>

            <el-form-item :label="$t('kaishishijian')" required>
              <yi_time_input
                type="datetime"
                :is_current="false"
                :time.sync="yt.editObj.startTime"
                format="yyyy-MM-dd HH:mm:ss"
                :disabled="yt.editObj.action === 'bianji'"
              >
              </yi_time_input>
            </el-form-item>

            <el-form-item :label="$t('jieshushijian')">
              <yi_time_input type="datetime" :is_current="false" :time.sync="yt.editObj.endTime" format="yyyy-MM-dd HH:mm:ss"> </yi_time_input>
            </el-form-item>

            <el-form-item :label="$t('beizhu')">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" v-model="yt.editObj.remark" maxlength="200" show-word-limit> </el-input>
            </el-form-item>
          </el-form>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" type="primary" :loading="yt.editObj.loading" @click="saveEdit">{{ $t('baocun') }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 选择停机原因（接口返回 -1 时触发） -->
    <el-dialog :show-close="true" :title="$t('tingjiyuanyin')" :visible.sync="faultDialogVisible" width="55%" :close-on-click-modal="false" append-to-body="append-to-body">
      <div class="dialog-content" v-loading="faultDialogLoading">
        <el-form :inline="true" size="mini" :label-width="yt.formLabelWidth">
          <div style="margin-bottom: 12px; padding-left: 80px; width: 100%">
            <el-tabs v-model="faultActiveTab">
              <el-tab-pane v-for="(item, faultTabIdx) in shutdownReasonList" :name="String(faultTabIdx)" :label="item.label" :key="item.label">
                <div class="container">
                  <el-button
                    @click="toggleFaultStandard(vos.id)"
                    :class="['fixed-width', { 'is-selected': selectedFaultStandardId === vos.id }]"
                    size="mini"
                    v-for="vos in item.faultStandardVOS"
                    :key="vos.id"
                    :title="vos.name"
                  >
                    {{ vos.name }}
                  </el-button>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="faultDialogVisible = false">{{ $t('quxiao') }}</el-button>
        <el-button size="mini" type="primary" :loading="yt.editObj.loading" @click="confirmFaultAndSave">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_equipment_trial_mold_record_list',
  data() {
    return {
      columns: [
        { label: 'shebeimingcheng', prop: 'equipment.name' },
        { label: 'mujubianhao', prop: 'mould.no' },
        { label: 'mujubianma', prop: 'mould.code' },
        { label: 'mojumingcheng', prop: 'mould.name' },
        { label: 'shengchangongdanhao', prop: 'wo.no' },
        { label: 'zhuangtai', type: 'slot', width: 90 },
        { label: 'suoshuzuzhi', prop: 'org.name' },
        { label: 'kaishishijian', prop: 'startTime', type: 'time', width: 180 },
        { label: 'jieshushijian', prop: 'endTime', type: 'time', width: 180 },
        { label: 'shichang(min)', type: 'slot', width: 110 },
        { label: 'jiluren', prop: 'recorderObject.nickname' },
        { label: 'beizhu', prop: 'remark' },
        { label: 'caozuo', type: 'slot', width: 150, fixed: 'right' }
      ],

      woLoading: false,
      woOptions: [],
      woCache: {},
      woAllLoaded: false,

      faultDialogVisible: false,
      faultDialogLoading: false,
      shutdownReasonList: [],
      faultActiveTab: '0',
      selectedFaultStandardId: null,
      pendingSave: null
    };
  },
  created() {
    setTimeout(() => {
      this.$set(this.yt.conditions, 'orderBy', 'id desc');
      this.yt.get(1);
    }, 300);
  },
  methods: {
    beforeShowEditDialogInsert(row) {
      const now = Date.now();
      const r = row || {};
      r.startTime = now;
      r.endTime = null;
      r.woId = null;
      r.equipmentId = null;
      r.mouldId = null;
      r.remark = '';
      return r;
    },

    beforeShowEditDialogEdit(row) {
      const r = row ? JSON.parse(JSON.stringify(row)) : {};
      r.woId = r.wo && r.wo.id != null ? r.wo.id : r.woId;
      r.equipmentId = r.equipment && r.equipment.id != null ? r.equipment.id : r.equipmentId;
      r.mouldId = r.mould && r.mould.id != null ? r.mould.id : r.mouldId;
      if (r.startTime == null) r.startTime = Date.now();
      if (r.woId) {
        this.$nextTick(() => {
          this.ensureWoOptionForId(r.woId);
        });
      }
      return r;
    },

    handleDialogClose() {
      this.woLoading = false;
      this.faultDialogVisible = false;
      this.faultDialogLoading = false;
      this.shutdownReasonList = [];
      this.faultActiveTab = '0';
      this.selectedFaultStandardId = null;
      this.pendingSave = null;
    },

    calcDurationMin(startMs, endMs) {
      const s = Number(startMs);
      const e = Number(endMs);
      if (!s || !e || e < s) return '';
      return ((e - s) / 1000 / 60).toFixed(1);
    },

    async fetchAllWo() {
      this.woLoading = true;
      try {
        const all = [];
        const pageSize = 500;
        let pageNo = 1;
        while (true) {
          const res = await this.http.get('/web/production/wo/page', {
            params: {
              pageNo,
              pageSize,
              statusList: ['2', '3', '4']
            }
          });
          const rows = (res && res.data && res.data.rows) || [];
          all.push(...rows);
          if (!rows || rows.length < pageSize) break;
          pageNo += 1;
        }

        const merged = [];
        const seen = {};

        (this.woOptions || []).forEach(it => {
          if (!it || it.id == null) return;
          if (seen[it.id]) return;
          seen[it.id] = true;
          merged.push(it);
        });

        all.forEach(it => {
          if (!it || it.id == null) return;
          if (seen[it.id]) return;
          seen[it.id] = true;
          merged.push(it);
        });

        this.woOptions = merged;
        this.woCache = {};
        merged.forEach(it => {
          if (it && it.id != null) this.woCache[it.id] = it;
        });
        this.woAllLoaded = true;
      } catch (err) {
        this.$message.error(this.$t(err));
      } finally {
        this.woLoading = false;
      }
    },

    async ensureWoOptionForId(woId) {
      if (!woId) return;
      if (this.woCache && this.woCache[woId]) return;
      if (this.woOptions && this.woOptions.find(it => it && it.id === woId)) return;

      try {
        const res = await this.http.get('/web/production/wo/page', {
          params: {
            pageNo: 1,
            pageSize: 1,
            id: woId
          }
        });
        const rows = (res && res.data && res.data.rows) || [];
        const wo = rows && rows.length > 0 ? rows[0] : null;
        if (!wo || wo.id == null) return;

        this.woOptions = [wo].concat(this.woOptions || []);
        if (!this.woCache) this.woCache = {};
        this.woCache[wo.id] = wo;
      } catch (err) {
        // 静默失败：仅用于回显下拉 label，不影响编辑保存
      }
    },

    handleWoDropdownVisibleChange(visible) {
      if (!visible) return;
      if (this.woLoading) return;
      if (this.woAllLoaded) return;
      this.fetchAllWo();
    },

    handleWoChange(id) {
      if (!id) {
        if (this.yt.editObj) {
          this.$set(this.yt.editObj, 'equipmentId', null);
          this.$set(this.yt.editObj, 'mouldId', null);
        }
        return;
      }
      const wo = this.woCache[id] || this.woOptions.find(it => it && it.id === id);
      if (!wo) return;
      if (wo.equipmentId != null && wo.equipmentId !== '') this.yt.editObj.equipmentId = wo.equipmentId;
      if (wo.mouldId != null && wo.mouldId !== '') this.yt.editObj.mouldId = wo.mouldId;
    },

    woStatusText(wo) {
      if (!wo) return '';
      const raw = wo.status != null ? wo.status : wo.woStat;
      const k = raw == null || raw === '' ? null : parseInt(raw);
      if (k == null || Number.isNaN(k)) return '';
      const dict = this.store && this.store.state && this.store.state.dictJsonAll && this.store.state.dictJsonAll['PRODUCTION_WO_STATUS'];
      const i18nKey = dict ? dict[k] : null;
      return i18nKey ? this.$t(i18nKey) : String(k);
    },

    buildSavePayload(faultStandardId) {
      const e = this.yt.editObj || {};
      const payload = {
        id: e.id,
        woId: e.woId || null,
        equipmentId: e.equipmentId,
        mouldId: e.mouldId || null,
        startTime: e.startTime,
        endTime: e.endTime || null,
        remark: e.remark || '',
        faultStandardId: faultStandardId != null ? faultStandardId : undefined
      };
      if (payload.faultStandardId === undefined) delete payload.faultStandardId;
      return payload;
    },

    async ensureShutdownReasonList() {
      if (this.shutdownReasonList && this.shutdownReasonList.length > 0) return;
      this.faultDialogLoading = true;
      try {
        const res = await this.http.get('web/equipment/fault/standard/getShutdownReasonTab');
        this.shutdownReasonList = res ? res.data : [];
      } catch (err) {
        this.$message.error(this.$t(err));
      } finally {
        this.faultDialogLoading = false;
      }
    },

    /** 试模记录停机原因弹窗：从生产配置 type=80 读取默认 faultStandardId */
    async applyDefaultFaultStandardFromConfig() {
      try {
        const res = await this.http.get('/web/production/config/list?type=80&status=1');
        const list = (res && res.data) || [];
        if (!Array.isArray(list) || list.length === 0) return;
        const row = list[0];
        let raw = row && row.configJson;
        if (raw == null || raw === '') return;
        let json = raw;
        if (typeof raw === 'string') {
          try {
            json = JSON.parse(raw);
          } catch (e) {
            return;
          }
        }
        if (!json || typeof json !== 'object') return;
        const id = json.faultStandardId;
        if (id == null || id === '') {
          this.syncFaultActiveTabToSelection();
          return;
        }
        const n = parseInt(id, 10);
        this.selectedFaultStandardId = Number.isNaN(n) ? id : n;
        this.syncFaultActiveTabToSelection();
      } catch (e) {
        // 静默：无配置时不影响用户手动选择
        this.syncFaultActiveTabToSelection();
      }
    },

    /** 根据已选停机原因 ID，切换到包含该项的分类 Tab */
    syncFaultActiveTabToSelection() {
      const id = this.selectedFaultStandardId;
      if (id == null || id === '') {
        this.faultActiveTab = '0';
        return;
      }
      const list = this.shutdownReasonList || [];
      for (let i = 0; i < list.length; i++) {
        const vos = list[i].faultStandardVOS || [];
        for (let j = 0; j < vos.length; j++) {
          if (vos[j].id == id) {
            this.faultActiveTab = String(i);
            return;
          }
        }
      }
      this.faultActiveTab = '0';
    },

    async doSaveWithOptionalFault(faultStandardId) {
      if (!this.yt || !this.yt.editObj) return;
      if (!this.yt.editObj.equipmentId) {
        this.$message.warning(this.$t('qingxuanze') + this.$t('shebeimingcheng'));
        return;
      }
      if (!this.yt.editObj.startTime) {
        this.$message.warning(this.$t('qingxuanze') + this.$t('kaishishijian'));
        return;
      }

      const url = this.yt.editObj.action === 'xinzeng' ? '/web/trial/mold/record/createOne' : '/web/trial/mold/record/updateOne';
      const payload = this.buildSavePayload(faultStandardId);

      this.yt.editObj.loading = true;
      try {
        const res = await this.http.post(url, payload);
        if (res && res.data === -1) {
          // 需要选择停机原因后再保存
          this.pendingSave = { url, payload: this.buildSavePayload(null) };
          this.selectedFaultStandardId = null;
          this.faultActiveTab = '0';
          this.faultDialogVisible = true;
          await this.ensureShutdownReasonList();
          await this.applyDefaultFaultStandardFromConfig();
          return;
        }

        this.faultDialogVisible = false;
        this.yt.isShowEditDialog = false;
        this.yt.get();
      } catch (err) {
        this.$message.error(this.$t(err));
      } finally {
        this.yt.editObj.loading = false;
      }
    },

    saveEdit() {
      this.doSaveWithOptionalFault(null);
    },

    confirmFaultAndSave() {
      if (!this.selectedFaultStandardId) {
        this.$message.warning(this.$t('qingxuanzetingjiyuanyin'));
        return;
      }
      this.doSaveWithOptionalFault(this.selectedFaultStandardId);
    },

    toggleFaultStandard(id) {
      if (this.selectedFaultStandardId === id) {
        this.selectedFaultStandardId = null;
        this.syncFaultActiveTabToSelection();
        return;
      }
      this.selectedFaultStandardId = id;
      this.syncFaultActiveTabToSelection();
    },

    voidRow(row) {
      if (!row || row.id == null) return;
      this.$confirm('是否确认作废此试模记录？', this.$t('tishi'), { type: 'warning' })
        .then(() => {
          return this.http.post('/web/trial/mold/record/void', { id: row.id });
        })
        .then(() => {
          this.$message.success(this.$t('caozuochenggong'));
          this.yt.get();
        })
        .catch(() => {});
    }
  }
};
</script>
